import React from "react";
import Translate from "react-translate-component";
export const Custom = ({
  fromComponent
}) => {
  return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Translate, {
    component: "span",
    content: fromComponent === "proposed_operation" ? "proposal.custom" : "transaction.custom"
  }));
};